// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"92872e63aac71619","5410":"6a706890140856f4","6184":"3a63a082af2d8024","7131":"6a706890140856f4"}[chunkId] + ".css";
};